/*
 * Convx A/B arm tag (2026-10-23): records which theme served the cart, so every order carries the
 * Shopify Rollouts arm as the cart attribute _convx_arm (= Shopify.theme.name). The underscore keeps it
 * out of checkout; it shows on the order in admin. Byte-identical in every arm.
 * Plan: projects/dreame-hk/audit/measurement-plans/2026-10-23_pdp-bundles-addons-ab-test.md
 *
 * Writes only when a cart exists (on load) or right after an add, once per session per theme name, so a
 * visitor who never adds anything never gets a cart from this script.
 */
(function () {
  var arm = window.Shopify && window.Shopify.theme && window.Shopify.theme.name;
  if (!arm || !window.fetch) return;
  var KEY = 'convx_arm_tagged';
  var busy = false;

  function done() {
    try { return window.sessionStorage.getItem(KEY) === arm; } catch (e) { return false; }
  }

  function tag() {
    if (busy || done()) return;
    busy = true;
    fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _convx_arm: arm } })
    }).then(function (res) {
      if (res.ok) {
        try { window.sessionStorage.setItem(KEY, arm); } catch (e) { /* private mode: tags again next page */ }
      }
    }).catch(function () { /* next page view retries */ }).then(function () { busy = false; });
  }

  if (/(^|;\s*)cart=/.test(document.cookie)) tag();
  document.addEventListener('afterCartChanged', tag);
  document.addEventListener('afterUpdateQuantity', tag);
})();
